export { default } from './EmailConfirmNoticeBlock';



// WEBPACK FOOTER //
// ./src/components/UserAccount/Confirms/ConfirmNoticeBlocks/EmailConfirmNoticeBlock/index.js